import { isCryptoCode } from 'shared/src/cryptoUtils';

import { hasValue } from 'utils/hasValue';

import type { VirtualAccount } from 'models/virtualAccount';

export const isCryptoAccount = (
  account: Partial<Pick<VirtualAccount, 'currency_code'>>
): boolean =>
  hasValue(account.currency_code) && isCryptoCode(account.currency_code);
